import LegalPage from './LegalPage';

export default function TermsPage() {
  return (
    <LegalPage
      title="Conditions d'utilisation"
      subtitle="Ces conditions definissent les regles d'utilisation de Foi Senegal, y compris la procedure de suppression de compte et de donnees."
      updatedAt="Derniere mise a jour : 11 juin 2026"
      intro="En utilisant Foi Senegal, l'utilisateur accepte les presentes conditions. L'application facilite l'acces aux informations religieuses, eglises, evenements, reservations, demandes de messe, commandes et services lies a la communaute catholique au Senegal."
      sections={[
        {
          title: '1. Acces au service',
          body: "L'utilisateur doit fournir des informations exactes lors de la creation de son compte et garder ses identifiants confidentiels. Foi Senegal peut suspendre un compte en cas d'usage frauduleux, abusif ou contraire aux presentes conditions.",
        },
        {
          title: '2. Utilisation autorisee',
          body: "L'application doit etre utilisee dans le respect des lois applicables, des autres utilisateurs, des eglises, des organisateurs et des vendeurs partenaires. Toute tentative de fraude, d'usurpation, de perturbation technique ou de publication de contenu illicite est interdite.",
        },
        {
          title: '3. Paiements, commandes et reservations',
          body: "Les paiements, commandes, tickets et reservations sont traites selon les informations affichees dans l'application au moment de la validation. Certaines donnees peuvent etre conservees pour respecter les obligations comptables, fiscales, de securite ou de prevention de fraude.",
        },
        {
          title: '4. Procedure de suppression de compte',
          body: "Pour supprimer son compte, l'utilisateur peut envoyer une demande a foisenegal@gmail.com depuis l'adresse email associee au compte, avec l'objet : Suppression de compte Foi Senegal. La demande doit indiquer le nom, l'email du compte et, si possible, le numero de telephone associe.\n\nApres verification de l'identite du demandeur, Foi Senegal confirme la prise en charge de la demande et procede a la suppression ou l'anonymisation des donnees eligibles dans un delai maximum de 90 jours.",
        },
        {
          title: '5. Conditions de suppression des donnees',
          body: "Sont supprimees ou anonymisees les donnees de profil, favoris, preferences, notifications et donnees personnelles non necessaires au respect d'une obligation legale. Les donnees liees aux paiements, factures, litiges, securite, prevention de fraude ou obligations comptables peuvent etre conservees pendant la duree requise par la loi, puis supprimees ou anonymisees.",
        },
        {
          title: '6. Responsabilite',
          body: "Foi Senegal s'efforce de fournir des informations fiables, mais certaines informations provenant de partenaires, eglises, organisateurs ou vendeurs peuvent evoluer. L'utilisateur est invite a verifier les informations importantes avant de se deplacer ou d'effectuer une transaction.",
        },
        {
          title: '7. Modification des conditions',
          body: "Foi Senegal peut mettre a jour ces conditions pour tenir compte de l'evolution du service, de la legislation ou des exigences des plateformes. La date de mise a jour indique la version applicable.",
        },
        {
          title: '8. Contact',
          body: "Pour toute question sur ces conditions ou la suppression de compte, contactez Foi Senegal a l'adresse foisenegal@gmail.com.",
        },
      ]}
    />
  );
}
